export default "__VITE_ASSET__aIiHLZ3___"